import { ChangeDetectionStrategy, Component } from '@angular/core';
import { StorageLocationMapBaseComponent } from '@luggagehero/features/ui';

@Component({
  selector: 'lh-storage-location-map',
  templateUrl: './storage-location-map.component.html',
  styleUrls: ['./storage-location-map.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class StorageLocationMapComponent extends StorageLocationMapBaseComponent {}
